import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { IMailingRule } from 'interfaces/MailingRule';
import {
  IMyKnownError,
  REQUEST_LIFE_CICLE,
  IPaginatedListResponse,
} from 'interfaces/requests';
import { get, MICROSERVICES } from 'api';
import endpoints from './endpoints';
import { IMailingRuleState, IMailingRuleListRequestParams } from './interfaces';
import { parseMailingRuleToList } from './helpers';
import { openAlert } from 'modules/alertHandler';

export const listMailingRulesAction = createAsyncThunk<
  IMailingRuleState,
  IMailingRuleListRequestParams | undefined,
  { rejectValue: IMyKnownError }
>(
  'mailingRuleList/fetch',
  async (payload = undefined, { dispatch, rejectWithValue }) => {
    try {
      const result = await get<IPaginatedListResponse<IMailingRule>>(
        MICROSERVICES.STRATEGIES,
        {
          url: endpoints.listMailingRules(),
          params: payload,
        },
      );
      const mailingRules = result.data.values.map((mailingRule) =>
        parseMailingRuleToList(mailingRule),
      );
      return {
        count: result.data.count,
        list: mailingRules,
      } as IMailingRuleState;
    } catch (error) {
      console.error('error at load mailingRule list', error);
      dispatch(
        openAlert({
          title: 'Ocorreu um erro!',
          content: 'Não foi possível carregar a lista de Regras',
        }),
      );
      return rejectWithValue(error.message);
    }
  },
);

const initialState = {
  loading: REQUEST_LIFE_CICLE.IDLE,
  list: [],
  count: 0,
} as IMailingRuleState;

const listSlice = createSlice({
  name: 'mailingRuleList',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(listMailingRulesAction.fulfilled, (state, action) => {
      state.count = action.payload.count;
      state.list = action.payload.list;
      state.loading = REQUEST_LIFE_CICLE.SUCCEEDED;
    });
    builder.addCase(listMailingRulesAction.pending, (state) => {
      state.count = initialState.count;
      state.list = initialState.list;
      state.loading = REQUEST_LIFE_CICLE.PENDING;
    });
    builder.addCase(listMailingRulesAction.rejected, (state) => {
      state.count = initialState.count;
      state.list = initialState.list;
      state.loading = REQUEST_LIFE_CICLE.FAILED;
    });
  },
});

const { reducer } = listSlice;
export default reducer;
